import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'

import chatService from '../services'

export function useMutationBanRoom() {
	return useMutation({
		mutationFn: ({
			roomId,
			isBanned,
			reason,
		}: {
			roomId: string
			isBanned: boolean
			reason?: string
		}) => chatService.banRoom(roomId, isBanned, reason),
		onSuccess: (_, variables) => {
			// SSE chat:room_banned handles cache invalidation
			toast.success(variables.isBanned ? 'ระงับห้องแล้ว' : 'ยกเลิกการระงับแล้ว')
		},
		onError: () => {
			toast.error('ดำเนินการล้มเหลว กรุณาลองใหม่อีกครั้ง')
		},
	})
}
